import React from 'react';
import { TopicStyles } from './mixins/mixins';
import { BackgroundValues } from './mixins/optionsValues';
import { StyleDropdownMenu, StyleSlider } from './components/common';

export const WallpaperStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleDropdownMenu
				key={'wallpaper'}
				name={'Wallpaper'}
				options={[
					{ name: 'Light', value: BackgroundValues.LIGHT },
					{ name: 'Dark', value: BackgroundValues.DARK },
					{ name: 'Picture', value: BackgroundValues.PICTURE }
				]}
				handleChange={(value: any) => {
					setStyle({
						...style,
						wallpaperStyle: { ...style.wallpaperStyle, ['background']: value }
					});
				}}
				optionState={style.wallpaperStyle.background}
			/>

			<StyleSlider
				key={'blur-range'}
				id={'blur-range'}
				name={'Blur'}
				initialValue={style.wallpaperStyle.blur}
				minValue={'0'}
				maxValue={'60'}
				step={'1'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						wallpaperStyle: { ...style.wallpaperStyle, ['blur']: value }
					});
				}}
			/>

			<StyleSlider
				key={'brightness-range'}
				id={'brightness-range'}
				name={'Brightness'}
				initialValue={style.wallpaperStyle.brightness}
				minValue={'0'}
				maxValue={'2'}
				step={'0.1'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						wallpaperStyle: { ...style.wallpaperStyle, ['brightness']: value }
					});
				}}
			/>
		</div>
	);
};
